import AppNavBar from './AppNavBar';
import Sidebar from './Sidebar';

export default function AppLayout({ children }) {
  return (
    <div className="app-layout">
      <AppNavBar />
      <div className="app-body">
        <Sidebar />
        <main className="app-content">
          {children}
        </main>
      </div>
    </div>
  );
}
